import Image from 'next/image';
import { useTranslations } from 'next-intl';

export default function HomePageLoadingShell() {
  const t = useTranslations('home');
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#070b14] px-6 text-white focus:outline-none"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(56,189,248,0.18),_transparent_42%),radial-gradient(circle_at_bottom,_rgba(16,185,129,0.16),_transparent_38%),linear-gradient(180deg,_rgba(7,11,20,0.94),_rgba(7,11,20,1))]" />
      <div className="absolute inset-0 opacity-30 [background-image:linear-gradient(rgba(148,163,184,0.08)_1px,transparent_1px),linear-gradient(90deg,rgba(148,163,184,0.08)_1px,transparent_1px)] [background-size:80px_80px]" />

      <div className="relative z-10 flex max-w-xl flex-col items-center text-center">
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-white/5 shadow-[0_0_40px_rgba(56,189,248,0.15)] backdrop-blur">
          <Image src="/ZenOpus_Icon.svg" alt="ZenOpus" width={40} height={40} className="rounded-xl" priority />
        </div>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.28em] text-cyan-200/80">ZenOpus</p>
        <h1 className="text-3xl font-semibold tracking-tight text-white sm:text-4xl">{t('loadingShell.title')}</h1>
        <p className="mt-4 max-w-md text-sm leading-6 text-slate-300 sm:text-base">{t('loadingShell.description')}</p>
        <div className="mt-8 flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-slate-200 backdrop-blur">
          <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-cyan-300" />
          <span>{t('loadingShell.compiling')}</span>
        </div>
      </div>
    </main>
  );
}
